// @flow

import React from "react";
import { FieldArray } from "react-final-form-arrays";

import TableRow from "./TableRow";
import { type SelectOption } from "../../Select";

import sharedStyles from "../shared/Shared.scss";

import styles from "./FundingSourceTable.scss";
import FieldArrayButtons from "../FieldArrayButtons";

type TableProps = {
  optionsToFilter: Array<string>,
  tableConfig: {
    options: Array<SelectOption>,
    tableHeader: string,
    arrayFieldName: string,
    firstColumnHeader: string,
    firstColumnFieldName: string,
    secondColumnFieldName: string,
    summaryHeader: string
  }
};

const Table = ({
  optionsToFilter,
  tableConfig,
  tableConfig: { options, tableHeader, arrayFieldName, firstColumnHeader }
}: TableProps) => (
  <div className={styles.fundingContainer}>
    <div className={styles.fundingList}>
      <div className={sharedStyles.caption}>{tableHeader}</div>

      <FieldArray name={arrayFieldName}>
        {({ fields }) => {
          if (fields.length === 0) {
            fields.push();
          }

          return (
            <React.Fragment>
              <table className={styles.table}>
                <thead className={styles.thead}>
                  <tr>
                    <th className={styles.normalText}>{firstColumnHeader}</th>
                    <th className={styles.normalText}>Betrag</th>
                  </tr>
                </thead>
                <tbody>
                  {fields.map((name, fieldIndex) => {
                    const isAddFieldVisible =
                      fields &&
                      options &&
                      fields.length - 1 === fieldIndex &&
                      fields.length < options.length;

                    const isRemoveFieldVisible = fields.length >= 2;

                    return (
                      // eslint-disable-next-line react/no-array-index-key
                      <React.Fragment key={fieldIndex}>
                        <TableRow
                          key={name}
                          name={name}
                          tableConfig={tableConfig}
                          optionsToFilter={optionsToFilter}
                        />
                        <tr>
                          <td colSpan={2} className={styles.rowButtons}>
                            <FieldArrayButtons
                              addField={{
                                handleClick: () => {
                                  fields.push();
                                },
                                text: () => "weitere hinzufügen",
                                isVisible: isAddFieldVisible
                              }}
                              removeField={{
                                handleClick: () => fields.remove(fieldIndex),
                                text: () => "Objekt entfernen",
                                isVisible: isRemoveFieldVisible
                              }}
                            />
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </React.Fragment>
          );
        }}
      </FieldArray>
    </div>
  </div>
);

export default Table;
